import script from "./named-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./named-icon.vue?vue&type=script&setup=true&lang=ts"

import "./named-icon.vue?vue&type=style&index=0&id=4b8124be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8124be"]])

export default __exports__